import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {
  @Input() messageContent: string;
  @Input() user: string;
  @Input() showIcon = false;
  @Input() currentUser = false;

  ngOnInit(): void {}
}
